<script setup lang="ts">
import type { CourseToolId } from '~/data/courseTools'

// PROPS
const props = defineProps({
  courseToolId: {
    type: String as PropType<CourseToolId | string>,
    required: true
  }
})

const { getCourseToolById } = useStaticData()

const tool = getCourseToolById(props.courseToolId)

const getToolImage = (id: string) => {
  return `/images/database/courses/tools/course-tool-${id}.png`
}
</script>

<template>
  <div>
    <div v-if="tool" class="course-tool">
      <img :src="getToolImage(tool.id)" >
      {{ tool.title }}
    </div>
    <div v-else class="course-tool">{{ props.courseToolId }}</div>
  </div>
</template>

<style scoped lang="scss">
.course-tool {
  font-size: 0.9rem;
  padding: 5px 15px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  background-color: var(--bgMedium);
  user-select: none;

  img {
    $size: 20px;
    height: $size;
    width: $size;
    margin-right: 10px;
    object-fit: contain;
  }
}
</style>
